module.exports = __webpack_public_path__ + "img/talron-menu-stations.4d8973e1.svg";